<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <button type="button" class="btn-close" (click)="cancel()"></button>
</div>
<form #templateForm="ngForm" name="createTCTemplateform" novalidate>
  <div class="modal-body">
    <div *ngIf="bulkSelectedOptionKey=='createTemplate'"
         class="form-group">
      <label>Name</label>
      <input type="text"
             appInputRestriction="restrictChars"
             class="form-control"
             id="name"
             name="name"
             ngModel
             autocomplete="off"
             [(ngModel)]="name"
             placeholder="Required"
             maxlength="60"
             required />
      <span *ngIf="showErrormsg"
            class="control-label control-label-error">{{errorMsg}}</span>
    </div>

    <div *ngIf="bulkSelectedOptionKey=='appendTemplate'"
         class="form-group">
      <label>Template</label>
      <div class="form-group">
        <nbc-select [source]="templates"
                    [(model)]="templateId"
                    [nbcRequired]="true"
                    display="name"
                    value="id"
                    name="templates"
                    placeHolderValue="-1"
                    placeHolderDisplay="Select Template"></nbc-select>
        <span *ngIf="showErrormsg"
              class="control-label control-label-error">{{errorMsg}}</span>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button *ngIf="bulkSelectedOptionKey=='createTemplate'"
            type="button"
            class="btn btn-primary"
            id="btnCreateTemplate"
            (click)="onCreate()"
            [attr.disabled]="submitted || null">
      {{confirmText}}
    </button>

    <button *ngIf="bulkSelectedOptionKey=='appendTemplate'"
            type="button"
            class="btn btn-primary"
            id="btnAppendTemplate"
            (click)="onAppend()"
            [attr.disabled]="submitted || null">
      {{confirmText}}
    </button>

    <button type="button"
            class="btn btn-default"
            (click)="cancel()">
      {{cancelText}}
    </button>
  </div>
</form>
